import { Controller } from "@hotwired/stimulus";

// Le choix du produit (GO4SCHOOL ou GO4LEARN) à la connexion et à l'inscription, en fenêtre —
// 2026-09-14. Servi par les liens du pied de page ; la barre du haut a ses menus déroulants.
//
// ⚠️ Sans script, le lien mène à l'écran GO4SCHOOL : c'est son `href`.
//
// data-controller="public-doors"
export default class extends Controller {
  static targets = ["dialog"];

  open(event) {
    const dialog = this.dialogTargets.find((d) => d.dataset.intent === event.params.intent);
    if (!dialog || typeof dialog.showModal !== "function") return;
    event.preventDefault();
    dialog.showModal();
    dialog.addEventListener("click", this.closeOnBackdrop);
  }

  close(event) {
    event.currentTarget.closest("dialog")?.close();
  }

  closeOnBackdrop = (event) => {
    if (event.target === event.currentTarget) event.currentTarget.close();
  };
}
